import {Component, Input} from '@angular/core';
import {DatasetUsageComponentObject} from "../../../../shared/classes/dataset-usage-component-object";

@Component({
  selector: 'app-custom-sources-badge-one-shot',
  templateUrl: './custom-sources-badge-one-shot.component.html',
  styleUrls: ['./custom-sources-badge-one-shot.component.scss']
})
export class CustomSourcesBadgeOneShotComponent {
  @Input() public datasource: DatasetUsageComponentObject;
}
